import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IonicModule } from '@ionic/angular';
import { PlanningRHService } from './services/planning-rh.service';
import { FavoritesModule } from '../preferences/favorites/favorites.module';
import { PipeModule } from '../../pipes';

@NgModule({
	declarations: [
	],
	exports: [],
	imports: [
		CommonModule,
		IonicModule,
		MatTableModule,
		MatTooltipModule,
		PipeModule,
		DragDropModule,
		FormsModule,
		FavoritesModule
	],
	providers: [PlanningRHService]
})
export class PlanningRHModule { }